import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import API, { auth } from '../../constants/api'
import {
  MEMBER_INFO_FETCH,
  MEMBER_CHANGE_PASS,
  MEMBER_EDIT,
  FAVORITE_LIST_FETCH,
  MEMBER_UPLOAD,
  NOTIFICATION_FETCH,
  MEMBER_DELETE,
  MEMBER_HISTORY_FETCH,
  MEMBER_UPDATE_SHOW_NOTI
} from '../actions'

import {
  memberInfoFetchSuccess,
  memberInfoFetchFail,
  changePassFetchSuccess,
  changePassFetchFail,
  memberEditinfoFetchSuccess,
  memberEditinfoFetchFail,
  favoriteListFetchSuccess,
  favoriteListFetchFail,
  memberUploadSuccess,
  memberUploadFail,
  ontificationListFetchSuccess,
  ontificationListFetchFail,
  memberDeleteFetchSuccess,
  memberDeleteFetchFail,
  memberHistoryFetchSuccess,
  memberHistoryFetchFail,
  memberUpdateShowNotiFetchSuccess,
  memberUpdateShowNotiFetchFail,
} from './actions'

/* member info */
const memberInfoFetchAsync = async (req) =>
  await API.post('/member/info', {
    "memberId": localStorage.getItem('user_id')
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* memberInfoFetch({ payload }) {
  const { memberInfo } = payload
  try {
    const memberInfoFetch = yield call(memberInfoFetchAsync, memberInfo)

    if (memberInfoFetch.data.StatusCode === '0000') {
      yield put(memberInfoFetchSuccess(memberInfoFetch.data.ResultValues))
      localStorage.setItem('user_info', JSON.stringify(memberInfoFetch.data.ResultValues));
    } else {
      yield put(memberInfoFetchFail(memberInfoFetch.data.Message))
    }
  } catch (error) {
    yield put(memberInfoFetchFail(error))
  }
}

/* change password */
const changePassFetchAsync = async (req) =>
  await API.post('/member/' + req.actionType, {
    "memberId": req.memberId,
    'oldPassword': req.oldPassword,
    'newPassword': req.newPassword
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* changePassFetch({ payload }) {
  const { changePass } = payload
  try {
    const changePassFetch = yield call(changePassFetchAsync, changePass)

    if (changePassFetch.data.StatusCode === '0000') {
      yield put(changePassFetchSuccess(changePassFetch.data.ResultValues))
      // console.log('data -> ', changePassFetch.data.ResultValues)
    } else {
      yield put(changePassFetchFail(changePassFetch.data.Message))
    }
  } catch (error) {
    yield put(changePassFetchFail(error))
  }
}

/* edit member info */
const memberEditinfoFetchAsync = async (req) =>
  await API.post('/member/' + req.actionType, {
    "memberId": req.memberId,
    "memberPrefix": req.memberPrefix,
    "memberFname": req.memberFname,
    "memberLname": req.memberLname,
    "memberBirthday": req.memberBirthday,
    "memberLine": req.memberLine,
    "memberPhone": req.memberPhone,
    "memberEmail": req.memberEmail,
    "provinceId": req.provinceId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* memberEditinfoFetch({ payload }) {
  const { memberEditinfo } = payload
  // console.log('memberEditinfo -> ', memberEditinfo)
  try {
    const memberEditinfoFetch = yield call(memberEditinfoFetchAsync, memberEditinfo)

    if (memberEditinfoFetch.data.StatusCode === '0000') {
      yield put(memberEditinfoFetchSuccess(memberEditinfoFetch.data.ResultValues))
    } else {
      yield put(memberEditinfoFetchFail(memberEditinfoFetch.data.Message))
    }
  } catch (error) {
    yield put(memberEditinfoFetchFail(error))
  }
}

/* favorite list */
const favoriteListFetchAsync = async (req) =>
  await API.post('/member/favoritelist', {
    "memberId": req.memberId,
    "page": req.page,
    "limit": req.limit,
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* favoriteListFetch({ payload }) {
  const { favoriteList } = payload
  try {
    const favoriteListFetch = yield call(favoriteListFetchAsync, favoriteList)

    if (favoriteListFetch.data.StatusCode === '0000') {
      yield put(favoriteListFetchSuccess(favoriteListFetch.data.ResultValues))
    } else {
      yield put(favoriteListFetchFail(favoriteListFetch.data.Messages))
    }
  } catch (error) {
    yield put(favoriteListFetchFail(error))
  }
}

/* upload */
const memberUploadAsync = async (req) =>
  await API.post('/member/uploadprofile', req, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: '558iim6kjkre38dxk2uj8i6yuew6gwa9',
      memberid: localStorage.getItem('user_id')
    }
  })
    .then((data) => data)
    .catch((error) => error)

function* memberUpload({ payload }) {
  const formData = new FormData()
  formData.append('fileupload', payload.memberUploadpic.fileupload)
  // console.log('upload pic : ', payload.memberUploadpic.fileupload)
  try {
    const memberUpload = yield call(memberUploadAsync, formData)

    if (memberUpload.data.StatusCode === '0000') {
      yield put(memberUploadSuccess(memberUpload.data.ResultValues))
      // console.log('upload pic : ', memberUpload.data.ResultValues)
    } else {
      yield put(memberUploadFail(memberUpload.data.Message))
    }
  } catch (error) {
    yield put(memberUploadFail(error))
  }
}

/* ontification list */
const ontificationListFetchAsync = async (req) =>
  await API.post('/member/notification', {
    "memberId": req.memberId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* ontificationListFetch({ payload }) {
  const { ontificationList } = payload
  try {
    const ontificationListFetch = yield call(ontificationListFetchAsync, ontificationList)

    if (ontificationListFetch.data.StatusCode === '0000') {
      yield put(ontificationListFetchSuccess(ontificationListFetch.data.ResultValues))
    } else {
      yield put(ontificationListFetchFail(ontificationListFetch.data.Messages))
    }
  } catch (error) {
    yield put(ontificationListFetchFail(error))
  }
}

/* delete */
const memberDeleteFetchAsync = async (req) =>
  await API.post('/member/delete', {
    "memberId": req.memberId,
    "password": req.password
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* memberDeleteFetch({ payload }) {
  const { memberDelete } = payload
  try {
    const memberDeleteFetch = yield call(memberDeleteFetchAsync, memberDelete)

    if (memberDeleteFetch.data.StatusCode === '0000') {
      yield put(memberDeleteFetchSuccess(memberDeleteFetch.data.Message))
    } else {
      yield put(memberDeleteFetchFail(memberDeleteFetch.data.Message))
    }
  } catch (error) {
    yield put(memberDeleteFetchFail(error))
  }
}

/* history */
const memberHistoryFetchAsync = async (req) =>
  await API.post('/member/historylist', {
    "memberId": req.memberId,
    "page": req.page,
    "limit": req.limit,
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* memberHistoryFetch({ payload }) {
  const { memberHistory } = payload
  try {
    const memberHistoryFetch = yield call(memberHistoryFetchAsync, memberHistory)

    if (memberHistoryFetch.data.StatusCode === '0000') {
      yield put(memberHistoryFetchSuccess(memberHistoryFetch.data.ResultValues))
    } else {
      yield put(memberHistoryFetchFail(memberHistoryFetch.data.Messages))
    }
  } catch (error) {
    yield put(memberHistoryFetchFail(error))
  }
}



const memberUpdateShowNotiFetchAsync = async (req) =>
  await API.post('/member/notification/update', {
    "memberId": req.memberId
  },
    {
      headers: auth
    }
  )
    .then((data) => data)
    .catch((error) => error)

function* memberUpdateShowNotiFetch({ payload }) {

  const { memberUpdateShowNoti } = payload
  try {
    const memberUpdateShowNotiFetch = yield call(memberUpdateShowNotiFetchAsync, memberUpdateShowNoti)

    if (memberUpdateShowNotiFetch.data.StatusCode === '0000') {
      yield put(memberUpdateShowNotiFetchSuccess(memberUpdateShowNotiFetch.data.ResultValues))
    } else {
      yield put(memberUpdateShowNotiFetchFail(memberUpdateShowNotiFetch.data.Messages))
    }
  } catch (error) {
    yield put(memberUpdateShowNotiFetchFail(error))
  }
}


export function* watchMemberFetch() {
  yield takeEvery(MEMBER_INFO_FETCH, memberInfoFetch)
  yield takeEvery(MEMBER_CHANGE_PASS, changePassFetch)
  yield takeEvery(MEMBER_EDIT, memberEditinfoFetch)
  yield takeEvery(FAVORITE_LIST_FETCH, favoriteListFetch)
  yield takeEvery(MEMBER_UPLOAD, memberUpload)
  yield takeEvery(NOTIFICATION_FETCH, ontificationListFetch)
  yield takeEvery(MEMBER_DELETE, memberDeleteFetch)
  yield takeEvery(MEMBER_HISTORY_FETCH, memberHistoryFetch)
  yield takeEvery(MEMBER_UPDATE_SHOW_NOTI, memberUpdateShowNotiFetch)


}

export default function* rootSaga() {
  yield all([fork(watchMemberFetch)])
}